
export const featuredProducts = [
  {
    id: 1,
    name: "قهوة عربية فاخرة - خليط الأصالة",
    price: 85,
    originalPrice: 120,
    rating: 5,
    image: "https://public.readdy.ai/ai/img_res/8e690438257241e47157ff99ee721978.jpg",
    category: "coffee"
  },
  {
    id: 2,
    name: "آلة تحضير القهوة الذكية",
    price: 1250,
    originalPrice: 1500,
    rating: 4,
    image: "https://readdy.ai/api/search-image?query=Modern%20smart%20coffee%20machine%2C%20sleek%20design%2C%20stainless%20steel%20finish%2C%20premium%20coffee%20maker%2C%20elegant%20kitchen%20appliance%2C%20sophisticated%20technology%2C%20luxury%20coffee%20equipment%2C%20professional%20grade%2C%20clean%20white%20background&width=300&height=300&seq=2&orientation=squarish",
    category: "machines"
  },
  {
    id: 3,
    name: "طقم أكواب قهوة كريستال فاخر",
    price: 180,
    rating: 5,
    image: "https://readdy.ai/api/search-image?query=Luxury%20crystal%20coffee%20cups%20set%2C%20elegant%20glassware%2C%20premium%20coffee%20cups%2C%20sophisticated%20design%2C%20golden%20rim%20details%2C%20high-end%20tableware%2C%20crystal%20clear%20glass%2C%20luxury%20dining%2C%20isolated%20on%20white%20background&width=300&height=300&seq=3&orientation=squarish",
    category: "accessories"
  },
  {
    id: 4,
    name: "مطحنة القهوة اليدوية التراثية",
    price: 320,
    rating: 4,
    image: "https://readdy.ai/api/search-image?query=Traditional%20manual%20coffee%20grinder%2C%20vintage%20brass%20design%2C%20heritage%20coffee%20equipment%2C%20handcrafted%20coffee%20mill%2C%20antique%20style%2C%20premium%20materials%2C%20artisanal%20coffee%20tools%2C%20classic%20design%2C%20warm%20lighting&width=300&height=300&seq=4&orientation=squarish",
    category: "tools"
  }
];

export const categories = [
  {
    id: 1,
    name: "القهوة الفاخرة",
    icon: "https://readdy.ai/api/search-image?query=icon%2C%203D%20cartoon%20coffee%20beans%2C%20premium%20coffee%20illustration%2C%20the%20icon%20should%20take%20up%2070%25%20of%20the%20frame%2C%20vibrant%20brown%20colors%20with%20soft%20gradients%2C%20minimalist%20design%2C%20smooth%20rounded%20shapes%2C%20subtle%20shading%2C%20no%20outlines%2C%20centered%20composition%2C%20isolated%20on%20white%20background%2C%20playful%20and%20friendly%20aesthetic%2C%20isometric%20perspective%2C%20high%20detail%20quality%2C%20clean%20and%20modern%20look%2C%20single%20object%20focus&width=100&height=100&seq=5&orientation=squarish",
    count: 25
  },
  {
    id: 2,
    name: "أدوات التحضير",
    icon: "https://readdy.ai/api/search-image?query=icon%2C%203D%20cartoon%20coffee%20brewing%20tools%2C%20coffee%20equipment%20illustration%2C%20the%20icon%20should%20take%20up%2070%25%20of%20the%20frame%2C%20vibrant%20colors%20with%20soft%20gradients%2C%20minimalist%20design%2C%20smooth%20rounded%20shapes%2C%20subtle%20shading%2C%20no%20outlines%2C%20centered%20composition%2C%20isolated%20on%20white%20background%2C%20playful%20and%20friendly%20aesthetic%2C%20isometric%20perspective%2C%20high%20detail%20quality%2C%20clean%20and%20modern%20look%2C%20single%20object%20focus&width=100&height=100&seq=6&orientation=squarish",
    count: 18
  },
  {
    id: 3,
    name: "آلات القهوة",
    icon: "https://readdy.ai/api/search-image?query=icon%2C%203D%20cartoon%20coffee%20machine%2C%20espresso%20maker%20illustration%2C%20the%20icon%20should%20take%20up%2070%25%20of%20the%20frame%2C%20vibrant%20colors%20with%20soft%20gradients%2C%20minimalist%20design%2C%20smooth%20rounded%20shapes%2C%20subtle%20shading%2C%20no%20outlines%2C%20centered%20composition%2C%20isolated%20on%20white%20background%2C%20playful%20and%20friendly%20aesthetic%2C%20isometric%20perspective%2C%20high%20detail%20quality%2C%20clean%20and%20modern%20look%2C%20single%20object%20focus&width=100&height=100&seq=7&orientation=squarish",
    count: 12
  },
  {
    id: 4,
    name: "الإكسسوارات",
    icon: "https://readdy.ai/api/search-image?query=icon%2C%203D%20cartoon%20coffee%20accessories%2C%20coffee%20cups%20and%20saucers%20illustration%2C%20the%20icon%20should%20take%20up%2070%25%20of%20the%20frame%2C%20vibrant%20colors%20with%20soft%20gradients%2C%20minimalist%20design%2C%20smooth%20rounded%20shapes%2C%20subtle%20shading%2C%20no%20outlines%2C%20centered%20composition%2C%20isolated%20on%20white%20background%2C%20playful%20and%20friendly%20aesthetic%2C%20isometric%20perspective%2C%20high%20detail%20quality%2C%20clean%20and%20modern%20look%2C%20single%20object%20focus&width=100&height=100&seq=8&orientation=squarish",
    count: 22
  }
];

export const bannerSlides = [
  {
    id: 1,
    title: "عروض خاصة على القهوة الفاخرة",
    subtitle: "خصم يصل إلى 30% على مجموعة مختارة",
    image: "https://readdy.ai/api/search-image?query=Premium%20coffee%20banner%2C%20luxury%20coffee%20beans%20background%2C%20elegant%20coffee%20shop%20atmosphere%2C%20warm%20brown%20and%20golden%20tones%2C%20sophisticated%20coffee%20culture%2C%20high-end%20coffee%20experience%2C%20professional%20photography%2C%20rich%20textures%2C%20cozy%20ambiance&width=350&height=180&seq=9&orientation=landscape",
    buttonText: "تسوق الآن"
  },
  {
    id: 2,
    title: "آلات القهوة الذكية الجديدة",
    subtitle: "تقنية متطورة لتحضير مثالي",
    image: "https://readdy.ai/api/search-image?query=Modern%20coffee%20machines%20banner%2C%20smart%20coffee%20technology%2C%20sleek%20kitchen%20appliances%2C%20contemporary%20design%2C%20premium%20coffee%20equipment%2C%20innovative%20brewing%20technology%2C%20clean%20modern%20aesthetic%2C%20professional%20lighting&width=350&height=180&seq=10&orientation=landscape",
    buttonText: "اكتشف المزيد"
  },
  {
    id: 3,
    title: "مجموعة الإكسسوارات الفاخرة",
    subtitle: "كل ما تحتاجه لتجربة قهوة مميزة",
    image: "https://readdy.ai/api/search-image?query=Luxury%20coffee%20accessories%20banner%2C%20elegant%20coffee%20cups%20and%20tools%2C%20premium%20coffee%20equipment%20collection%2C%20sophisticated%20coffee%20culture%2C%20golden%20accents%2C%20warm%20lighting%2C%20high-end%20lifestyle&width=350&height=180&seq=11&orientation=landscape",
    buttonText: "استكشف التشكيلة"
  }
];
